import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NouisliderModule } from "ng2-nouislider";
import { TagInputModule } from "ngx-chips";
import { MaterialModule } from "../../app.module";

import { TablasModule } from "./tablas/tablas.module";
import { SharedModule } from "../shared.module";

import { TableComponent } from "./table/table.component";
import { FilterComponent, NuevoPaciente } from "./filter/filter.component";
import { TableSelectComponent } from "./table-select/table-select.component";
import { IndexComponent } from "./index/index.component";
import { FilterLineItemsComponent } from "./filter-line-items/filter-line-items.component";
import { FilterScrapsComponent } from "./filter-scraps/filter-scraps.component";
import { SelectFilterComponent } from "./select-filter/select-filter.component";
import { LoadingComponent } from "./loading/loading.component";
import { NotfoundComponent } from "./notfound/notfound.component";
import { MultiFilesComponent } from "./multi-files/multi-files.component";
import { FilterObjectComponent } from "./filter-object/filter-object.component";
import { SearcherComponent } from "./searcher/searcher.component";
import { PagerComponent } from "./pager/pager.component";
import { MailBox } from "./mail-box/mail-box.component";
import { MessageInputComponent } from "./message-input/message-input.component";
import { Usernametag } from "../../pipes/usernametag.pipe";
import { LightboxModule } from "ngx-lightbox";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { DinamicTableComponent } from "./dinamic-table/dinamic-table.component";
import { CheckboxDynamicComponent } from "./checkbox-dynamic/checkbox-dynamic.component";
import { FilterSoComponent } from "./filter-so/filter-so.component";
import { ContainerCrudComponent } from "./containerCrud/containerCrud.component";
import { CommentsComponent } from "./comments/comments.component";
import { BatchPiComponent } from "../../batch-container-inventory/batch-pi/batch-pi.component";
import { BatchComponent } from "./batch/batch.component";
import { CardComponent } from "./card/card.component";
import { ButtonComponent } from "./button/button.component";
import { TextFieldComponent } from "./text-field/text-field.component";
import { ContainerphotosComponent } from "./containerphotos/containerphotos.component";
import { MultiselectAutocompleteComponent } from "./multiselect-autocomplete/multiselect-autocomplete.component";
import { attributeMultipleItemsComponent } from "./attribute-multiple-items/attribute-multiple-items.component";
import { MatTreeModule } from "@angular/material/tree";
import { AlertComponent } from "./alert/alert.component";
import { PiCommentsComponent } from "./pi-comments/pi-comments.component";
import { TransportationDetailsComponent } from "./transportation-details/transportation-details.component";
import { TableTrakingCopyComponent } from "./table-traking-copy/table-traking-copy.component";
import { TableTrakingComponent } from "./table-traking/table-traking.component";
import { MultiselectComponent } from "./multiselect/multiselect.component";
import { CheckboxTreeComponent } from "./checkbox-tree/checkbox-tree.component";
import { CheckboxTreeMonthComponent } from "./checkbox-tree-month/checkbox-tree-month.component";
import { ChipCustomComponent } from "./chip-custom/chip-custom.component";
import { ButtonSelectComponent } from "./button-select/button-select.component";
import { SkeletonTableComponent } from "./skeleton-table/skeleton-table.component";
import { CardWidgetComponent } from "./card-widget/card-widget.component";
import { AvatarComponent } from "./avatar/avatar.component";
import { NgApexchartsModule } from "ng-apexcharts";
import { FormatNumberPipe } from "../../pipes/format-number";
import { ButtonMenuComponent } from './button-menu/button-menu.component';
@NgModule({
  declarations: [
    TableComponent,
    FilterComponent,
    TableSelectComponent,
    IndexComponent,
    FilterLineItemsComponent,
    NuevoPaciente,
    FilterScrapsComponent,
    SelectFilterComponent,
    LoadingComponent,
    NotfoundComponent,
    MultiFilesComponent,
    FilterObjectComponent,
    SearcherComponent,
    PagerComponent,
    MailBox,
    MessageInputComponent,
    Usernametag,
    DinamicTableComponent,
    CheckboxDynamicComponent,
    FilterSoComponent,
    ContainerCrudComponent,
    CommentsComponent,
    BatchPiComponent,
    BatchComponent,
    CardComponent,
    ButtonComponent,
    TextFieldComponent,
    ContainerphotosComponent,
    MultiselectAutocompleteComponent,
    attributeMultipleItemsComponent,
    AlertComponent,
    PiCommentsComponent,
    TransportationDetailsComponent,
    TableTrakingCopyComponent,
    TableTrakingComponent,
    MultiselectComponent,
    CheckboxTreeComponent,
    CheckboxTreeMonthComponent,
    ChipCustomComponent,
    ButtonSelectComponent,
    SkeletonTableComponent,
    CardWidgetComponent,
    AvatarComponent,
    FormatNumberPipe,
    ButtonMenuComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NouisliderModule,
    TagInputModule,
    MaterialModule,
    TablasModule,
    SharedModule,
    CKEditorModule,
    LightboxModule,
    MatTreeModule,
    RouterModule,
    NgApexchartsModule,
  ],
  exports: [
    TablasModule,
    TableComponent,
    FilterComponent,
    TableSelectComponent,
    IndexComponent,
    FilterLineItemsComponent,
    FilterScrapsComponent,
    SelectFilterComponent,
    LoadingComponent,
    NotfoundComponent,
    MultiFilesComponent,
    FilterObjectComponent,
    SearcherComponent,
    PagerComponent,
    MessageInputComponent,
    DinamicTableComponent,
    CheckboxDynamicComponent,
    FilterSoComponent,
    ContainerCrudComponent,
    CommentsComponent,
    BatchPiComponent,
    BatchComponent,
    CardComponent,
    ButtonComponent,
    TextFieldComponent,
    ContainerphotosComponent,
    MultiselectAutocompleteComponent,
    attributeMultipleItemsComponent,
    AlertComponent,
    PiCommentsComponent,
    TransportationDetailsComponent,
    TableTrakingComponent,
    TableTrakingCopyComponent,
    MultiselectComponent,
    CheckboxTreeComponent,
    CheckboxTreeMonthComponent,
    ChipCustomComponent,
    ButtonSelectComponent,
    SkeletonTableComponent,
    CardWidgetComponent,
    AvatarComponent,
    FormatNumberPipe,
    ButtonMenuComponent,
  ],
  entryComponents: [
    NuevoPaciente,
    ContainerCrudComponent,
    ContainerphotosComponent,
    AlertComponent,
  ],
})
export class ComponentsModule {}
